import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useAuthStore } from '@/features/auth/stores/authStore';

interface ProtectedRouteProps {
  allowedRoles?: string[];
}

// faro-console: 開発ユーザーのみアクセス可能
const ALLOWED_CONSOLE_ROLE = '開発ユーザー';

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  // 認証チェックはApp.tsxで完了しているため、ここでは状態のみ参照
  const { isAuthenticated, user, logout } = useAuthStore();

  // 未認証の場合はログイン画面へリダイレクト
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // faro-console: 開発ユーザーのみアクセス許可
  const hasConsoleAccess = user?.role?.roleName === ALLOWED_CONSOLE_ROLE;

  if (!hasConsoleAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Result
          status="403"
          title="アクセス拒否"
          subTitle="このコンソールにアクセスする権限がありません。開発ユーザーのみアクセス可能です。"
          extra={
            <Button type="primary" onClick={() => logout()}>
              ログアウト
            </Button>
          }
        />
      </div>
    );
  }

  // 追加のロールベースのアクセス制御
  if (allowedRoles && user) {
    const hasRequiredRole = allowedRoles.includes(user.role.roleName);
    if (!hasRequiredRole) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <Outlet />;
};